import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=8d12ddd6&"
import script from "./OffersTable.vue?vue&type=script&lang=ts&"
export * from "./OffersTable.vue?vue&type=script&lang=ts&"
import style0 from "./OffersTable.vue?vue&type=style&index=0&id=8d12ddd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports